import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";

const ExclusivePackage = () => {
  return (
    <div className="w-full bg-white pb-[100px]">
      <div className="flex flex-col items-center justify-between w-[80%] max-xxxl:w-[90%] m-auto text-center">
        {/* Header Section */}
        <h2 className="leading-[70px] tracking-[-3px] font-sora">
          Unlock your Exclusive Package
        </h2>
        <p className="text-lg md:text-xl text-[#718096] ">
          Let Donna AI be your Personalised Companion
        </p>
      </div>

      {/* Content Section */}
      <div className="flex max-md:flex-col  justify-between items-start gap-8 mt-12  m-auto w-[80%] max-xxxl:w-[90%]">
        {/* Left Box */}
        <div className="w-1/2 max-md:w-full bg-white p-6 rounded-[20px] h-[255px] md-m:h-fit shadow-[0px_0px_10.9px_0px_rgba(0,_4,_47,_0.15)]">
          <h6 className="font-bold mb-4">Effortless Workflow</h6>
          <ol className="list-decimal list-inside text-left space-y-4 text-[#718096]">
            <li>
              <span className="medium">Instant Client Profiling:</span> Simply
              input client details and watch our AI conduct a comprehensive
              preliminary assessment.
            </li>
            <li>
              <span className="medium">Lawyer Matching:</span> Automatically
              assign the most suitable lawyer based on case complexity and
              expertise.
            </li>
            <li>
              <span className="medium">Case Viability Predictions:</span>{" "}
              Receive a data-driven probability of case success, saving you
              countless hours of unnecessary preparation.
            </li>
          </ol>
        </div>

        {/* Right Box */}
        <div className="w-1/2 max-md:w-full bg-white p-6 rounded-[20px] md-m:h-fit h-[255px] shadow-[0px_0px_10.9px_0px_rgba(0,_4,_47,_0.15)]">
          <h6 className="font-bold mb-4">Why we're Different</h6>
          <p className="text-left space-y-4 text-[#718096] medium">
            Custom-Tailored Intelligence: We create a hyper-personalised
            screening process that aligns perfectly with your practice's DNA.
          </p>
          <br />
          <p className="text-left space-y-4 text-[#718096] flex">
            Predictive Case Potential: Our advanced algorithms don't just screen
            - they predict. We
            {/* <Icon
              icon="material-symbols-light:balance"
              width="24"
              height="24"
            />
            <br /> */}
            help you identify high-potential cases before traditional methods
            catch up.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExclusivePackage;
